import { render, staticRenderFns } from "./SocialMediaGrouped.vue?vue&type=template&id=0bab1173&"
import script from "./SocialMediaGrouped.vue?vue&type=script&lang=js&"
export * from "./SocialMediaGrouped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bab1173')) {
      api.createRecord('0bab1173', component.options)
    } else {
      api.reload('0bab1173', component.options)
    }
    module.hot.accept("./SocialMediaGrouped.vue?vue&type=template&id=0bab1173&", function () {
      api.rerender('0bab1173', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/views/SocialMediaGrouped.vue"
export default component.exports